import React, { useEffect, useState, useContext } from 'react';
import Personal from './Personal';
import Questions from './Questions';
import { fetchForms, submitForm } from '../../utils/apiServices';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';

function Diagnosis() {
  const navigate = useNavigate();
  const [currentFormIndex, setCurrentFormIndex] = useState(null);
  const [forms, setForms] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [answers, setAnswers] = useState([]);
  const [personalData, setPersonalData] = useState({});
  const [isCompleted, setIsCompleted] = useState(false);
  const [isPersonalCompleted, setIsPersonalCompleted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const { user } = useContext(AuthContext);

  useEffect(() => {
    fetchForms().then(data => {
      setForms(data.results);
    });

    const savedFormIndex = localStorage.getItem('currentFormIndex');
    if (savedFormIndex !== null) {
      setCurrentFormIndex(JSON.parse(savedFormIndex));
    }

    const savedAnswers = localStorage.getItem('formAnswers');
    if (savedAnswers) {
      setAnswers(JSON.parse(savedAnswers));
    }

    const savedQuestionIndex = localStorage.getItem('currentQuestionIndex');
    if (savedQuestionIndex) {
      setCurrentQuestionIndex(JSON.parse(savedQuestionIndex));
    }

    const savedPersonalData = localStorage.getItem('personalData');
    if (savedPersonalData) {
      setPersonalData(JSON.parse(savedPersonalData));
      setIsPersonalCompleted(true);
    }
  }, []);

  useEffect(() => {
    if (error) {
      // Solo limpiar los datos del formulario, no el token de sesión
      localStorage.removeItem('currentQuestionIndex');
      localStorage.removeItem('personalData');
      localStorage.removeItem('formAnswers');
      localStorage.removeItem('currentFormIndex');
      console.error('Error en el diagnóstico, limpiando datos del formulario:', error);
    }
  }, [error]);


  const handlePersonalSubmit = (data) => {
    setPersonalData(data);
    setIsPersonalCompleted(true);
    localStorage.setItem('personalData', JSON.stringify(data));
  };

  // Nuevo useEffect para calcular el índice del formulario seleccionado
  useEffect(() => {
    if (
      forms.length > 0 &&
      personalData.company_type &&
      typeof personalData.company_type === 'string'
    ) {
      const tipoIndex = forms.findIndex(form => form.title === personalData.company_type);
      setCurrentFormIndex(tipoIndex);
      localStorage.setItem('currentFormIndex', JSON.stringify(tipoIndex));
    }
  }, [forms, personalData]);

  const handleAnswerSelect = (answerId) => {
    const question = forms[currentFormIndex].questions[currentQuestionIndex];
    const answer = question.answers.find(a => a.id === answerId);
    if (!answer) return;

    const newAnswer = {
      questionId: question.id,
      answerId: answer.id,
      value: answer.value,
      category: question.category,
      answers_count: question.answers_count,
      questionText: question.text,
      answerText: answer.text,
    };

    setSelectedAnswer(answerId);
    setAnswers(current => {
      const updatedAnswers = current.filter(a => a.questionId !== question.id).concat(newAnswer);
      localStorage.setItem('formAnswers', JSON.stringify(updatedAnswers));
      return updatedAnswers;
    });
  };

  const handleFormSubmit = () => {
    setIsSubmitting(true);
    
    // Usar los datos del usuario autenticado
    const userDocument = user?.document || personalData.document;
    const userEmail = user?.email || personalData.email;
    
    const submissionData = {
      answers: answers,
      info: personalData
    };
    
    console.log('Enviando formulario:', {
      formTitle: forms[currentFormIndex]?.title,
      userDocument,
      userEmail,
      answersCount: answers.length,
      token: user?.token ? 'Token presente' : 'Sin token'
    });
    
    submitForm(
      forms[currentFormIndex].title,
      userDocument,
      userEmail,
      submissionData,
      user?.token
    )
      .then((response) => {
        console.log('Formulario enviado exitosamente:', response);
        setIsCompleted(true);
        localStorage.removeItem('currentQuestionIndex');
        localStorage.removeItem('personalData');
        localStorage.removeItem('formAnswers');
        localStorage.removeItem('currentFormIndex');
        navigate('/resultados');
      })
      .catch(error => {
        console.error('Error al enviar el formulario:', error);
        alert('Error al enviar el formulario: ' + (error.message || 'Error desconocido'));
        setIsSubmitting(false);
      });
  };

  const handleNavigation = (direction) => {
    if (direction === 'next' && selectedAnswer !== null) {
      if (currentQuestionIndex < forms[currentFormIndex]?.questions.length - 1) {
        setCurrentQuestionIndex(current => current + 1);
        setSelectedAnswer(null);
        localStorage.setItem('currentQuestionIndex', JSON.stringify(currentQuestionIndex + 1));
      } else {
        // Última pregunta - enviar el formulario
        handleFormSubmit();
      }
    } else if (direction === 'previous' && currentQuestionIndex > 0) {
      setCurrentQuestionIndex(current => current - 1);
      setSelectedAnswer(null);
      localStorage.setItem('currentQuestionIndex', JSON.stringify(currentQuestionIndex - 1));
      setAnswers(current => {
        const updatedAnswers = current.filter(a => a.questionId !== forms[currentFormIndex].questions[currentQuestionIndex].id);
        localStorage.setItem('formAnswers', JSON.stringify(updatedAnswers));
        return updatedAnswers;
      });
    }
  };

  const handleReturnToPersonal = () => {
    // Limpiar los datos guardados y volver al formulario inicial
    setIsPersonalCompleted(false);
    setPersonalData({});
    setCurrentQuestionIndex(0);
    setSelectedAnswer(null);
    setAnswers([]);
    localStorage.removeItem('currentQuestionIndex');
    localStorage.removeItem('personalData');
    localStorage.removeItem('formAnswers');
    localStorage.removeItem('currentFormIndex');
  };

  return (
    <>
      {!isCompleted && !isPersonalCompleted ? (
        <Personal onFormSubmit={handlePersonalSubmit} formNames={forms.map(form => form.title)} />
      ) : !isCompleted && isPersonalCompleted ? (
        forms.length > 0 && currentFormIndex !== null && currentFormIndex >= 0 && forms[currentFormIndex] && (
          <Questions
            form={forms[currentFormIndex]}
            currentQuestionIndex={currentQuestionIndex}
            selectedAnswer={selectedAnswer}
            onSelectAnswer={handleAnswerSelect}
            onNavigate={handleNavigation}
            isSubmitting={isSubmitting}
            onReturnToPersonal={handleReturnToPersonal}
          />
        )
      ) : null}
    </>
  );
}

export default Diagnosis;